module.exports = __webpack_public_path__ + "static/img/loading.5f47ce57.gif";